import { createSlice } from '@reduxjs/toolkit';

import type { EcomPromotion } from '../../../models/domain/ecommerce/promotion/promotion';

import { setFullCart } from './cartHydrationActions';

const slice = createSlice({
    name: 'promos',
    initialState: [] as EcomPromotion[],
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.promos);
    },
});

export const { actions, reducer } = slice;

export default reducer;
